module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_m_albino.82355bf2.png";